<header class="header">
    <div class="header__wrapper">
      <button
        (click)="navToggle()"
        class="nav__toggle"
        aria-label="Menu Toggle"
        aria-controls="primary-navigation"
        aria-expanded={isVisible}
      >
        <span></span>
      </button>
      <a
        class="header__logo"
        aria-label="Home"
        href="/"
        (click)="hideNav()"
      >
        <app-logo class="logo"></app-logo>
      </a>
      <!-- <Link href={"/category/бела%20техника"} class="nav-search-link">
        <Image src={searchImg} alt="search" />
      </Link> -->
      <nav aria-label="Main Navigation" class="nav">
        <ul class="nav__list" id="primary-navigation">
          <!-- <li class="nav__list-item">
            <button
              (click)="navToggle()"
              class="nav__list-link"
            >
              Сите категории
              <app-arrow-down className="nav__list-link__icon" />
            </button>
          </li> -->
          <!-- {/* <li class="nav__list-item">
            <Link class="nav__list-link" href="/catalogs">
              Каталози
            </Link>
          </li> */} -->
          <!-- <li class="nav__list-item">
            <CustomLink class="nav__list-link" href="/best-deals">
              Најдобри зделки
            </CustomLink>
          </li> -->
          <li class="nav__list-item">
            <a class="nav__list-link" href="/about">
              За нас
            </a>
          </li>
        </ul>

        <!-- <div id="search-nav">
           <app-search></app-search>
        </div> -->

        <!-- {session ? (
          <a class="nav__user" href="/profile">
            <Image
              src={
                session.user.image
                  ? `/api/imagefetcher?url=${encodeURIComponent(
                      session.user.image
                    )}`
                  : "/icons/blank-profile-picture.png"
              }
              alt="user"
              width={50}
              height={50}
            />
          </Link>
        ) : ( -->
          <button
          hidden="true"
            style="margin-left: 'auto'"

          >
          <!-- (click)="setShowModal(true)" -->
            Најавете се
          </button>
      </nav>
    </div>
</header>
